export enum ExpirationStatusEnum {
  Active = 0,
  NearingExpiration,
  Expired
}
